import protobuf from "protobufjs";
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import proto from "./message.json";

const root = protobuf.Root.fromJSON(proto);

export enum ChatType {
  UNKNOW = 0,
  /**
   * 单聊
   */
  CHAT = 1,
  /**
   * 群聊
   */
  GROUPCHAT = 2,
  /**
   * 广播
   */
  ALL = 3,

  /*授权*/
  AUTH = 5,

  /**
   *心跳消息
   */
  PING = 9,
  /**
   * 返回结果
   */
  RESULT = 10,
  /**
   * 消息回执
   */
  RECEIPT = 11
}

export enum Command {
  /*握手请求，含http的websocket握手请求*/
  COMMAND_HANDSHAKE_REQ = 1,
  /*握手响应，含http的websocket握手响应*/
  COMMAND_HANDSHAKE_RESP = 2,
  /*登录消息请求*/
  COMMAND_AUTH_REQ = 5,
  /*登录消息结果*/
  COMMAND_AUTH_RESP = 6,
  /*关闭请求*/
  COMMAND_CLOSE = 7,
  /*聊天请求*/
  COMMAND_CHAT = 10,
  /*消息回执*/
  MESSAGE_RECEIPT = 11,
  /*拉取 聊天历史记录 */
  PULL_MESSAGE_RECORD_REQ = 12,
  /*拉取 聊天历史记录 结果*/
  PULL_MESSAGE_RECORD_RESP = 13,
  /*批量拉取群组消息数量  请求*/
  PULL_BATCH_GROUP_MESSAGE_REQ = 14,
  /*批量拉取群组消息数量  结果*/
  PULL_BATCH_GROUP_MESSAGE_RESP = 15,
  /*失败错误*/
  ERROR = -1,
  /*登陆 被挤下线*/
  // eslint-disable-next-line @typescript-eslint/camelcase
  Login_Conflict = -3,
  /*加入群组*/
  JOINGROUP_REQ = 20,
  /*退出群组*/
  EXITGROUP_REQ = 21,
  /*群组请求结果协议*/
  GROUP_REQUEST_RESULT = 22,
  /*心跳消息*/
  // eslint-disable-next-line @typescript-eslint/camelcase
  Ping_REQ = 99,
  /*成功请求*/
  SUCCESS = 100
}

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
interface IProtoMessageType {
  messageHead: any;
  chatMessage: any;
  authMessageReq: any;
  authMessageResp: any;
  messageReceipt: any;
  joinGroupMessage: any;
  exitGroupMessage: any;
  groupMessageResp: any;
  pullMessageHistoryRecordReq: any;
  pullMessageHistoryRecordResp: any;
  pullBatchGroupMessageReq: any;
  pullBatchGroupMessageResp: any;
  pingMessage: any;
  commonSuccess: any;
  commonError: any;
}

export const ProtoMessageType: IProtoMessageType = {
  messageHead: root.lookupType("Message.MessageHead"),
  chatMessage: root.lookupType("Message.ChatMessage"),
  authMessageReq: root.lookupType("Message.AuthMessage"),
  authMessageResp: root.lookupType("Message.AuthRespMessageProBuf"),
  messageReceipt: root.lookupType("Message.MessageReceiptStatusProBuf"),
  joinGroupMessage: root.lookupType("Message.JoinGroupMessageProBuf"),
  exitGroupMessage: root.lookupType("Message.ExitGroupMessageProBuf"),
  groupMessageResp: root.lookupType("Message.GroupMessageRespProBuf"),
  pullMessageHistoryRecordReq: root.lookupType(
    "Message.PullMessageHistoryRecordReqProBuf"
  ),
  pullMessageHistoryRecordResp: root.lookupType(
    "Message.PullMessageHistoryRecordRespProBuf"
  ),
  pullBatchGroupMessageReq: root.lookupType(
    "Message.PullBatchGroupMessageReqProBuf"
  ),
  pullBatchGroupMessageResp: root.lookupType(
    "Message.PullGroupMessageRespProBuf"
  ),
  pingMessage: root.lookupType("Message.PingMessageProBuf"),
  commonSuccess: root.lookupType("Message.CommonSuccessProBuf"),
  commonError: root.lookupType("Message.CommonErrorProBuf")
};

export type ProtoMessageEnum = keyof IProtoMessageType | any;
